import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      width: '600px'
    },
  }),
);

const ModalDinamyc = (props: {
  open: boolean,
  title: string,
  content: any
}) => {
  const classes = useStyles();

  return (
    <>
      <div className="p-1">
        <Modal
          aria-labelledby="Add Property"
          aria-describedby="Add Property Modal"
          className={classes.modal}
          open={props.open}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 300,
          }}
          disableBackdropClick
        >
          <Fade in={props.open}>
            <div className={classes.paper}>
              <div className="bg-lightBlueDS title white p-3">
                {props.title}
              </div>
              {props.content}
            </div>
          </Fade>
        </Modal>
      </div>
    </>
  )
}

export default ModalDinamyc
